<p *ngIf="data?.data?.data">
  {{data?.data?.data?.balance}}
</p>
<p *ngIf="data?.data?.error">
  0
</p>
